import { useEffect } from 'react';
import posthog from 'posthog-js';
import { useAuth } from './AuthContext';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

let initialized = false;

export function initPostHog() {
  if (!POSTHOG_KEY || initialized) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false, // keep it clean until you explicitly enable
  });
  initialized = true;
}

// Call this once at app start
initPostHog();

// Hook: call inside a component to identify the logged-in user
export function usePostHogIdentify() {
  const { user } = useAuth();
  useEffect(() => {
    if (!initialized) return;
    if (user?.id) {
      posthog.identify(user.id, {
        email: user.email,
        name: user.name,
        role: user.role,
      });
    } else {
      posthog.reset();
    }
  }, [user]);
}

export default posthog;
